import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactForm.css";
import { Checkbox, Snackbar, Alert } from "@mui/material";
import { Link } from "react-router-dom";

const ContactForm = () => {
  const form = useRef();
  const [alertEmail, setAlertEmail] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, type: "success" });

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validateEmail(userEmail)) {
      setAlertEmail(true);
      return;
    }

    setIsSending(true);

    emailjs
      .sendForm(
        "service_sespgbn",
        "template_u4kngki",
        form.current,
        "f3RgRAV7cR38cW2a4"
      )
      .then(() => {
        setSnackbar({ open: true, type: "success" });
        setAlertEmail(false);
        setIsSending(false);
        form.current.reset();
        setUserEmail("");
      })
      .catch(() => {
        setSnackbar({ open: true, type: "error" });
        setIsSending(false);
      });
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <div className="Contact">
      <div className="contact-container">
        <form ref={form} onSubmit={sendEmail}>
          <h2>Contact</h2>
          <p>
            Vous pouvez contacter facilement le cabinet en remplissant le
            formulaire ci-contre. Une réponse vous sera donnée dans les
            meilleurs délais.
          </p>
          <div className="form-group-name">
            <div className="form-name">
              <label htmlFor="name">Nom :</label>
              <input type="text" name="name" required />
            </div>
            <div className="form-name">
              <label htmlFor="surname">Prénom :</label>
              <input type="text" name="surname" required />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="email">Email :</label>
            <input
              type="email"
              name="email"
              value={userEmail}
              onChange={(e) => {
                setUserEmail(e.target.value);
                setAlertEmail(false);
              }}
              required
            />
            {alertEmail && (
              <p className="valiation-error">L'adresse mail n'est pas valide</p>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="message">Message :</label>
            <textarea id="message" name="message" required />
          </div>
          <div className="mention-rgpd">
            <Checkbox
              value="checkedA"
              inputProps={{ "aria-label": "Checkbox A" }}
              required
            />
            <p>
              En cochant cette case, vous consentez à la collecte et au
              traitement de vos données personnelles par le cabinet de Maître
              Camille Doré dans le but de traiter votre demande conformément à
              notre{" "}
              <Link to="/confidentialité">
                <span className="option">politique de confidentialité</span>
              </Link>
            </p>
          </div>

          <button className="CTA" type="submit" disabled={isSending}>
            {isSending ? "Envoi en cours…" : "Envoyer"}
          </button>
        </form>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          severity={snackbar.type}
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          {snackbar.type === "success"
            ? "Votre message a bien été envoyé. Nous vous répondrons dans les meilleurs délais."
            : "Une erreur est survenue lors de l'envoi. Veuillez réessayer ou nous contacter par email."}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ContactForm;
